import { createSlice } from '@reduxjs/toolkit'
import { getCostItems, saveCostItem, createCostItem, deleteCostItem } from './costItemActions'

const initialState = {
  costitems: [],
  loading: false,
  loadingError: false,
  savingError: false,
  saving: false,
  saved: false,
  savedCostItem: {},
  deleting: false,
  deleted: false,
  deletingError: false,
}

function isRejectedAction(action) {
  return action.type.endsWith('rejected')
}

const costitemsSlice = createSlice({
  name: 'costitems',
  initialState,
  reducers: {
    clear: (state) => {
      state.saved = false
      state.savingError = false
      state.loadingError = false
      state.savedCostItem = {}
      state.deleting = false
      state.deleted = false
      state.deletingError = false
    },
  },

  extraReducers: (builder) => {
    // Add reducers for additional action types here, and handle loading state as needed
    builder
      .addCase(getCostItems.fulfilled, (state, { payload }) => {
        state.loading = false
        state.costitems = payload
        /*payload.forEach((i) => {
          state.costitems[i.id] = i
        })*/
      })
      .addCase(getCostItems.pending, (state) => {
        state.loading = true
        state.loadingError = null
        state.savingError = null
      })
      .addCase(getCostItems.rejected, (state, { payload }) => {
        state.loading = false
        state.loadingError = payload
      })
      .addCase(saveCostItem.pending, (state) => {
        state.saving = true
        state.savingError = null
        state.saved = false
      })
      .addCase(saveCostItem.fulfilled, (state, { payload }) => {
        state.savingError = null
        //state.costitems[state.costitems.findIndex((p) => p.id === payload.id)] = payload
        state.savedCostItem = payload
        state.saved = true
        state.saving = false
      })
      .addCase(saveCostItem.rejected, (state, { payload }) => {
        state.saving = false
        state.savingError = payload
        state.saved = false
      })
      .addCase(createCostItem.pending, (state) => {
        state.saving = true
        state.savingError = null
        state.saved = false
      })
      .addCase(createCostItem.fulfilled, (state, { payload }) => {
        state.savingError = null
        state.savedCostItem = payload
        state.saved = true
        state.saving = false
      })
      .addCase(createCostItem.rejected, (state, { payload }) => {
        state.saving = false
        state.savingError = payload
        state.saved = false
      })
      .addCase(deleteCostItem.pending, (state) => {
        state.deleting = true
        state.deletingError = null
        state.deleted = false
      })
      .addCase(deleteCostItem.fulfilled, (state) => {
        state.deletingError = null
        state.deleted = true
        state.deleting = false
      })
      .addCase(deleteCostItem.rejected, (state, { payload }) => {
        state.deleting = false
        state.deletingError = payload
        state.deleted = false
      })
    /*.addMatcher(
        isRejectedAction,
        // `action` will be inferred as a RejectedAction due to isRejectedAction being defined as a type guard
        (state, { payload }) => {
          state.loading = false
          state.error = payload
        },
      )*/
  },
})

export const { clear } = costitemsSlice.actions
export default costitemsSlice.reducer
